export const logo = "/assets/logos/logo.png";
